// extracted by mini-css-extract-plugin
export default {"tableRow":"tableRow__YDaHs"};